import { useTranslation } from "react-i18next";
import casesService from "api/casesService";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useParams } from "react-router";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { useContext, useEffect, useMemo } from "react";
import CaseCard from "components/CaseCard";
import statusService from "api/statusService";
import tagsService from "api/tagsService";
import CasesContext from "contexts/CasesContext";
import NotFoundScreen from "components/NotFoundScreen";

const CasesClient: FC<Props> = () => {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const { data: casesData } = casesService.useGetCases({
    page: 0,
    ParticipantId: clientId ?? "",
  });

  const { cases: casesContext, setCases } = useContext(CasesContext);

  useEffect(() => {
    setCases(casesData?.data.Items ?? []);
  }, [clientId, casesData]);

  const { data: tagsData } = tagsService.useGetTags();
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const { data: statusesData } = statusService.useGetStatuses();
  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);

  return (
    <div className={styles.wrapper}>
      {casesContext.length === 0 && (
        <div className={styles.empty}>
          <NotFoundScreen
            size="small"
            title={t("emptyStates.noCases")}
            text={t("emptyStates.noCasesText")}
            buttonName={t("emptyStates.addCase")}
            onClick={() => {}}
          />
        </div>
      )}

      {casesContext.map((c: ICaseSimple) => (
        <CaseCard
          key={c.Id}
          className={styles.card}
          c={c}
          showS={false}
          tags={tags}
          statuses={statuses}
          setSelectedEdit={() => {}}
        />
      ))}
    </div>
  );
};

export default CasesClient;
